export default "__VITE_ASSET__LlW$BotQ__"